import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { safeLocalStorage } from "~/utils/safeStorage";
import {
  getFilterUrl,
  getType,
  getWordLat,
  getWordSound,
} from "../../../../utils";
import styles from "./index.module.scss";
import { setIsFilterLoading } from "../../../../redux/action-creaters/filter";
import Icon from "../../../common/icon";

function isFiltered(filter, name, library = []) {
  if (!filter?.trim()) {
    return true;
  }

  const filterArray = filter.trim().toLowerCase().replace("-", " ").split(" ");
  filterArray.forEach((filterPiece) => {
    filterArray.push(getWordSound(filterPiece));
    filterArray.push(getWordLat(filterPiece));
  });

  filterArray.forEach((filterPiece) => {
    library.forEach((librarySet) => {
      librarySet.forEach((libraryItem) => {
        if (libraryItem.includes(filterPiece)) {
          filterArray.push(...librarySet);
        }
      });
    });
  });

  let isFound = false;
  filterArray.forEach((filterPiece) => {
    if (
      name.toLowerCase().includes(filterPiece) ||
      name.toLowerCase().replace("-", "").includes(filterPiece)
    ) {
      isFound = true;
    }
  });

  return isFound;
}

export default function SelectorMobile({ sectionPageUrl }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const { marks, topMarks, models, types } = useSelector(
    (state) => state.models,
  );
  const marksMap = marks ?? {};
  const topMarksList = Array.isArray(topMarks) ? topMarks : [];
  const modelsMap = models ?? {};
  const typesMap = types ?? {};
  const { params } = useSelector((state) => state.filter);

  const changeMark = (value) => {
    if (!value) {
      return;
    }
    safeLocalStorage.setItem("mark_", value);
    safeLocalStorage.setItem("model_", "");
    safeLocalStorage.setItem("type_", "");
    dispatch(setIsFilterLoading(true));
    const url = getFilterUrl(sectionPageUrl, params, { marka: value });
    router.push(`${url}?isShowFilter=y`);
  };

  const changeModel = (value) => {
    if (!value) {
      return;
    }
    safeLocalStorage.setItem("model_", value);
    safeLocalStorage.setItem("type_", "");
    dispatch(setIsFilterLoading(true));
    router.push(
      `${getFilterUrl(sectionPageUrl, params, {
        model: value,
      })}?isShowFilter=y`,
    );
  };

  const changeTypes = (value) => {
    if (!value) {
      return;
    }
    safeLocalStorage.setItem("type_", value);
    safeLocalStorage.setItem(
      "filterUrl",
      `/filter/marka-${params.marka?.[0]}/model-${params.model?.[0]}/kuzov-${value}`,
    );
    dispatch(setIsFilterLoading(true));
    router.push(getFilterUrl(sectionPageUrl, params, { kuzov: value }));
  };

  // eslint-disable-next-line no-unused-vars
  const [isSelectOther, setIsSelectOther] = useState(false);

  const markKeys = Object.keys(marksMap).sort();
  const topMarksByCode = useMemo(() => {
    const topMarksCode = {};
    topMarksList.forEach((mark) => {
      topMarksCode[mark.CODE] = mark;
    });
    return topMarksCode;
  }, [topMarksList]);

  const [q, setQ] = useState("");

  const filteredOptions = useMemo(() => {
    if (q) {
      return markKeys.filter((item) => {
        return isFiltered(q, item.toLowerCase());
      });
    }
    return markKeys;
  }, [markKeys]);

  const searchText = useMemo(() => {
    if (!params?.marka) {
      return "Поиск марки";
    }
    if (!params?.model) {
      return "Поиск модели";
    }
    return "Выбор кузова";
  }, []);

  const modelsKeys = Object.keys(modelsMap).sort();

  return markKeys.length > 0 ? (
    <div className={styles.SelectorSearch}>
      {!params?.marka && (
        <div className={styles.Search}>
          <input
            placeholder={searchText}
            value={q}
            onChange={(event) => setQ(event.target.value)}
          />
          {!q ? (
            <Icon id="search" stroke={"#9294A9"} strokeWidth={2} size={24} />
          ) : (
            <div
              className={styles.Close}
              onClick={() => {
                setQ("");
              }}
            >
              <Icon id="close" fill={"#333"} size={24} />
            </div>
          )}
        </div>
      )}
      {!params?.marka && (
        <div className={styles.SelectorSearchList}>
          {filteredOptions.map((markKey) => (
            <div
              key={markKey}
              className={styles.Item}
              onClick={() => {
                changeMark(markKey);
              }}
            >
              <span>
                <img src={topMarksByCode[markKey]?.PICTURE_SRC} />
              </span>
              <div>{marksMap[markKey]?.NAME}</div>
            </div>
          ))}
        </div>
      )}
      {!params?.model && (
        <div className={styles.SelectorSearchList}>
          {modelsKeys.map((modelKey) => (
            <div
              key={modelKey}
              className={styles.Item}
              onClick={() => {
                changeModel(modelKey);
              }}
            >
              <div>{modelsMap[modelKey]?.NAME}</div>
            </div>
          ))}
        </div>
      )}
      {!params?.kuzov && (
        <div className={styles.SelectorSearchList}>
          {Object.keys(typesMap)
            .map((typeCode) => getType(typesMap[typeCode].NAME, typeCode))
            .sort((a, b) => a.sort - b.sort)
            .map((item) => (
              <div
                key={item.code}
                className={styles.Item}
                onClick={() => {
                  changeTypes(item.code);
                }}
              >
                <div>{`${item.name} ${item.gen}`}</div>
              </div>
            ))}
        </div>
      )}
    </div>
  ) : null;
}
